import { render, staticRenderFns } from "./Pill.vue?vue&type=template&id=e0b60efe&scoped=true"
import script from "./Pill.vue?vue&type=script&lang=js"
export * from "./Pill.vue?vue&type=script&lang=js"
import style0 from "./Pill.vue?vue&type=style&index=0&id=e0b60efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b60efe",
  null
  
)

export default component.exports